import { render, staticRenderFns } from "./SelectMultiField.vue?vue&type=template&id=823d6c3c&"
import script from "./SelectMultiField.vue?vue&type=script&lang=js&"
export * from "./SelectMultiField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports